module.exports = __webpack_public_path__ + "img/ludo.d22bd720.jpg";